import { useMemo, useSyncExternalStore } from 'react';

import { getStoredGuestLikes, subscribeGuestLikes } from '../store';
import { type GuestLikedProduct } from '../types';

import { safeJsonParse } from '@/modules/storage/helpers';

export function useGuestLikedProducts() {
  const stored = useSyncExternalStore(
    subscribeGuestLikes,
    getStoredGuestLikes,
    () => undefined
  );
  return useMemo(() => {
    const likes: GuestLikedProduct[] = safeJsonParse(stored, []);
    return likes.toSorted((a, b) => b.timestamp - a.timestamp);
  }, [stored]);
}
